import React from 'react';
import PropTypes from 'prop-types';

import { InteractiveResultPropType } from 'propTypes/common';

import Button from 'components/Button';

// eslint-disable-next-line import/no-cycle
import Results from '../Results';

import styles from './styles.module.scss';

const SectionResults = ({
	questionsAmount,
	restartTest,
	resultMetadata,
	score,
	showCorrectAnswersAmount
}) => (
	<>
		<Results
			{...{
				score,
				questionsAmount,
				resultMetadata,
				showCorrectAnswersAmount
			}}
		/>
		<Button
			onClick={restartTest}
			title="Пройти еще"
			className={styles.RepeatButton}
		/>
	</>
);

SectionResults.propTypes = {
	questionsAmount: PropTypes.number.isRequired,
	restartTest: PropTypes.func.isRequired,
	resultMetadata: InteractiveResultPropType.isRequired,
	score: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	showCorrectAnswersAmount: PropTypes.bool
};

export default SectionResults;
